import { DataProviderListResult } from "../data-provider.interfaces";

export const getEmptyObjectListResult = <TResult = any>(): DataProviderListResult<TResult> => {
    return {
        objects: [],
        totalCount: 0,
        error: null
    }
}
